import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cx } from '@/lib/cx';

export type ButtonVariant = 'default' | 'primary' | 'soft' | 'danger' | 'ghost' | 'whatsapp';
export type ButtonSize = 'default' | 'small' | 'large' | 'icon';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  default: '',
  primary: 'primary',
  soft: 'soft',
  danger: 'danger',
  ghost: 'ghost',
  whatsapp: 'whatsapp-btn',
};

const SIZE_CLASS: Record<ButtonSize, string> = {
  default: '',
  small: 'small',
  large: 'large',
  icon: 'icon-only',
};

/** Prototype .btn (CSS line 31). Defaults to type="button" so forms submit only through explicit submit buttons. */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'default', size = 'default', className, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cx('btn', VARIANT_CLASS[variant], SIZE_CLASS[size], className)}
      {...rest}
    />
  );
});
